import { render, staticRenderFns } from "./CardList-dealer.vue?vue&type=template&id=0a12ae7a&"
import script from "./CardList-dealer.vue?vue&type=script&lang=js&"
export * from "./CardList-dealer.vue?vue&type=script&lang=js&"
import style0 from "./CardList-dealer.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports